import { useState } from "react";
import useDesktopMediaQuery from "hooks/useDesktopMediaQuery";
import { useNotifications } from "utils/hooks/useNotifications";
import { schedule_types_ids } from "features/Listings/constants/Listings.constants";
import { copyToClipboard } from "features/Common/utils/Copy.utils";

export const useManageRecordingsListTable = (recordingProps) => {
  const { parentOffering } = recordingProps || {};
  const isDesktop = useDesktopMediaQuery();
  const { notify } = useNotifications();

  const [shareModalData, setShareModalData] = useState(null);

  const isRecordedCourse = parentOffering?.type === schedule_types_ids.content;

  const handleOpenShareModal = (record) => {
    setShareModalData(record);
  };

  const handleCloseShareModal = () => {
    setShareModalData(null);
  };

  const handleCopyShareUrl = () => {
    if (shareModalData?.share_url) {
      copyToClipboard(shareModalData.share_url, notify);
    }
  };

  const handleCopyPassword = (passVal) => {
    const passwordToCopy =
      typeof passVal === "string" ? passVal : shareModalData?.password;

    if (passwordToCopy) {
      copyToClipboard(passwordToCopy, notify);
    }
  };

  return {
    isDesktop,
    isRecordedCourse,
    shareModalData,
    handleOpenShareModal,
    handleCloseShareModal,
    handleCopyShareUrl,
    handleCopyPassword,
  };
};

export default useManageRecordingsListTable;
